import React from 'react';

import FormFieldLabel from './FormFieldLabel';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

interface IProps extends IFormFieldProps {
  placeholder?: string;
}

function FormTextField({ name, label, optional, placeholder, size = 50 }: IProps) {
  const { id, fieldProps, inputProps } = useFormField(name, size);

  return (
    <div {...fieldProps}>
      {label && (
        <FormFieldLabel htmlFor={id} optional={optional}>
          {label}
        </FormFieldLabel>
      )}
      <input type="text" placeholder={placeholder} {...inputProps} />
    </div>
  );
}

export default FormTextField;
